"use strict";

exports.__esModule = true;
exports.default = getInlineCookies;

/**
 * Retourne les cookies dans le format attendu par le header `Cookie` d’une requête.
 * @param {object} cookies
 * @return {string}
 */
function getInlineCookies(cookies) {
  return Object.entries(cookies).map(function ([cookieName, cookieValue]) {
    return `${cookieName}=${cookieValue}`;
  }).join(";");
}